import React from 'react';
import {connect} from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import {Typography, Card, CardMedia, CardContent} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        width: 300,
        height: '100%',
        margin:10
    },
    media: {
        paddingTop: '56.25%',
        overflow: 'hidden',
        justifyContent: 'center',
        alignItems: 'center'
    },
}));


/**
 *  This will be a card containing a few dish's data like name, a picture and description
 * @param recipe            {object}: recipe's data
 * @return {*}
 * @constructor
 */
const RecipeCard =({recipe})=> {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <Link to={{pathname: `/recettes/${recipe.id}`}}>
                <CardMedia className={classes.media} image={recipe.image}/>
            </Link>
            <CardContent>
                <Typography variant="body2" align={'center'}>{recipe.name}</Typography>
            </CardContent>
        </Card>
    );
};


export default connect(
    null,
    null
)(RecipeCard)
